import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Users, ChevronRight, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobileCRMCustomersPage() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/crm/customers`).then(r => setCustomers(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = customers.filter(c => !search || (c.company_name || c.name || '').toLowerCase().includes(search.toLowerCase()));

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Customers</div>
      <div style={{ position: 'relative', marginBottom: 14 }}>
        <Search size={16} style={{ position: 'absolute', left: 12, top: 13, color: '#8e8e93' }} />
        <input className="mobile-input" placeholder="Search customers..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
      </div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total</div><div className="mobile-kpi-value">{customers.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Active</div><div className="mobile-kpi-value">{customers.filter(c => c.status === 'active' || c.status === 'Active').length}</div></div>
      </div>
      {filtered.length === 0 ? <div className="mobile-empty-state"><Users /><p>No customers</p></div> : (
        <div className="mobile-menu-list">
          {filtered.map(c => (
            <button key={c.customer_id || c.id} className="mobile-menu-item" onClick={() => navigate(`/mobile/crm/customers/${c.customer_id || c.id}`)}>
              <div className="mobile-menu-item-icon" style={{ background: '#34c759' }}><Users size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{c.company_name || c.name}</div>
                <div className="mobile-menu-item-subtitle">{c.industry || 'N/A'} · {c.status || 'Active'} · {c.location || ''}</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
